import { ReportDescription as _ReportDescription } from '@team-milva/lab-models/resources'

export class ReportDescription extends _ReportDescription {}
